/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { GenderIdentity } from "./GenderIdentity";
import type { HomeAddressRequest } from "./HomeAddressRequest";
import type { InsuranceInfoRequest } from "./InsuranceInfoRequest";
import type { PreferredPharmacyRequest } from "./PreferredPharmacyRequest";
import type { Pronoun } from "./Pronoun";
import type { SexAtBirth } from "./SexAtBirth";

/**
 * Request schema for upserting a user profile
 */
export interface UserProfileRequest {
  email?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  preferred_name?: string | null;
  date_of_birth?: string | null;
  sex_at_birth?: SexAtBirth | null;
  gender_identity?: GenderIdentity | null;
  pronouns?: Pronoun | null;
  /** US state or territory abbreviation */
  state_of_residence?: string | null;
  home_address?: HomeAddressRequest | null;
  /** IANA timezone identifier */
  timezone?: string | null;
  preferred_pharmacy?: PreferredPharmacyRequest | null;
  insurance?: InsuranceInfoRequest | null;
}
